import { Flex, Link, Text } from "@chakra-ui/react";
import React from "react";
import { LinkedinIcon, XIcon } from "ui/icons";
import { NavItem } from "./nav-item";

export function SocialAndLegalLinks() {
  return (
    <Flex
      align="center"
      direction={{ base: "column", lg: "row" }}
      justify="space-between"
      width="100%"
      gap="bigger"
      px={{ base: "big", lg: "bigger", xl: "0" }}
    >
      <Flex gap="big">
        <Link
          aria-label="Hightouch on LinkedIn"
          variant="footer"
          target="_blank"
          href="https://www.linkedin.com/company/hightouchio/"
          rel="noreferrer"
        >
          <LinkedinIcon boxSize="icon.sm" />
        </Link>

        <Link
          aria-label="Hightouch on X"
          variant="footer"
          target="_blank"
          href="https://x.com/HightouchData"
          rel="noreferrer"
          position="relative"
        >
          <XIcon boxSize="icon.sm" />
        </Link>
      </Flex>

      <Flex direction={{ base: "column-reverse", lg: "row" }} w={{ base: "100%", sm: "auto" }} align="center" gap="big">
        <Text textStyle="caption2" flexShrink={0}>
          Hightouch © {new Date().getFullYear()}
        </Text>

        <Flex w="100%" gap={{ base: "tiny", sm: "big" }} justifyContent="space-between">
          <NavItem href="/privacy-policy" color="brand.textSecondary.dark">
            Privacy Policy
          </NavItem>
          <NavItem href="/terms-of-service" color="brand.textSecondary.dark">
            Terms of Service
          </NavItem>
          <NavItem href="https://status.hightouch.io/" color="brand.textSecondary.dark">
            Status
          </NavItem>
          <NavItem href="/platform/security" color="brand.textSecondary.dark">
            Security
          </NavItem>
        </Flex>
      </Flex>
    </Flex>
  );
}
